<template>
  <div class="vip-layout-background" :class="$vuetify.breakpoint.mdAndUp ? 'px-12' : 'px-2'">
    <router-view></router-view>
  </div>
</template>

<script>
import { uiHelper, locale } from '@/util'
export default {
  name: 'vipLayout',
  // metaInfo:{
  //   link:[
  //     {
  //       rel:'canonical', href:'https://jaya9.co/jayarank/challenge/'
  //     }
  //   ]
  //
  // },
  data: () => ({}),
  created() {
    this.metaTag()
  },
  methods: {
    metaTag() {
      const isBetDomain = window.location.hostname.includes('jaya9.bet')
      const isBestDomain = window.location.hostname.includes('jaya9.best')
      const isCashDomain = window.location.hostname.includes('jaya9.cash')

      uiHelper.setMetaTag('url', window.location.origin + '/jayarank/challenge/')
      uiHelper.setMetaTag('keywords', `${locale.getMessage('meta.challenge_keyword')}`)
      uiHelper.setCanonical('/jayarank/challenge/')
      if (isBetDomain) {
        uiHelper.setTitle(`${locale.getMessage('meta.challenge_title_bet')}`)
        // uiHelper.setMetaTag('title', `${locale.getMessage('meta.challenge_title_bet')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.challenge_description_bet')}`)
        uiHelper.setMetaTagProp('og:title', `${locale.getMessage('meta.challenge_title_bet')}`)
        uiHelper.setMetaTagProp('og:description', `${locale.getMessage('meta.challenge_description_bet')}`)
      } else if (isBestDomain) {
        uiHelper.setTitle(`${locale.getMessage('meta.challenge_title_best')}`)
        // uiHelper.setMetaTag('title', `${locale.getMessage('meta.challenge_title_best')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.challenge_description_best')}`)
        uiHelper.setMetaTagProp('og:title', `${locale.getMessage('meta.challenge_title_best')}`)
        uiHelper.setMetaTagProp('og:description', `${locale.getMessage('meta.challenge_description_best')}`)
      } else if (isCashDomain) {
        uiHelper.setTitle(`${locale.getMessage('meta.challenge_title_cash')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.challenge_description_cash')}`)
        uiHelper.setMetaTagProp('og:title', `${locale.getMessage('meta.challenge_title_cash')}`)
        uiHelper.setMetaTagProp('og:description', `${locale.getMessage('meta.challenge_description_cash')}`)
      } else {
        uiHelper.setTitle(`${locale.getMessage('meta.challenge_title')}`)
        // uiHelper.setMetaTag('title', `${locale.getMessage('meta.challenge_title')}`)
        uiHelper.setMetaTag('description', `${locale.getMessage('meta.challenge_description')}`)
        uiHelper.setMetaTagProp('og:title', `${locale.getMessage('meta.challenge_title')}`)
        uiHelper.setMetaTagProp('og:description', `${locale.getMessage('meta.challenge_description')}`)
      }
    },
    openLoginDialog() {
      this.$parent.openLoginDialog()
    },
    openRegisterDialog() {
      this.$parent.openRegisterDialog()
    }
  }
}
</script>

<style lang="scss">
.vip-layout-background {
  width: 100%;
  height: 100%;
  /*background: url("/static/image/GrabCoins/icon/bj.png") no-repeat top left;*/
  overflow-y: hidden;
  overflow-x: hidden;
  position: relative;
  margin: 0 auto;
  background-size: 100%;
  background: url('/static/image/background/kk-vip-background.jpeg');
  background-size: cover;
}
</style>
